import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Typography } from '@mui/material';
import React from 'react';
import { UploadDemographicAPIProps } from '../../models/APITransationLog/IAPITransationLog';
import Footer from '../Footer/Footer';
import StyledTableRow from '../GlobalStyles/StyledTableRow';
import { StyledTableCell } from '../GlobalStyles/TableStyledCell';
import { useRowStyles } from './APITransactionLogCss';
import ViewMoreDemographicAPI from './ViewMoreDemographicAPI';
import StyledCell from '../GlobalStyles/StyledCell';
import moment from 'moment';
import { useGlobalState } from '../../store/GlobalStore';

const UploadDemographicAPI: React.FC<UploadDemographicAPIProps> = ({ uploadDemographicAPILogList, totalDemographicAPICount, page, rowsPerPage, order, orderBy, onSortChange, onPageChange, onRowsPerPageChange }) => {
    const classes = useRowStyles();
    const { state } = useGlobalState();

    const headCells = [
        { id: "clientNo", disablePadding: false, label: "CLIENT CODE", sortable: true, fontSize: '12px' },
        { id: "cLT_NAME_1", disablePadding: false, label: "CLIENT NAME", sortable: true, fontSize: '12px' },
        { id: "firstName_ResponsibleParty", disablePadding: false, label: "FIRST NAME", sortable: true, fontSize: '12px' },
        { id: "lastName_ResponsibleParty", disablePadding: false, label: "LAST NAME", sortable: true, fontSize: '12px' },
        { id: "phase", disablePadding: false, label: "PHASE", sortable: true, fontSize: '12px' },
        { id: "billingAddressLine1", disablePadding: false, label: "ADDRESS LINE 1", sortable: true, fontSize: '12px' },
        { id: "billingAddressLine2", disablePadding: false, label: "ADDRESS LINE 2", sortable: true, fontSize: '12px' },
        { id: "billingCity", disablePadding: false, label: "CITY", sortable: true, fontSize: '12px' },
        { id: "billingState", disablePadding: false, label: "STATE", sortable: true, fontSize: '12px' },
        { id: "billingZipCode", disablePadding: false, label: "ZIP CODE", sortable: true, fontSize: '12px' },
        { id: "billingPhoneNumber", disablePadding: false, label: "PHONE NUMBER", sortable: true, fontSize: '12px' },
        { id: "createdDate", disablePadding: false, label: "CREATED DATE", sortable: true, fontSize: '12px' },
        { id: "billingPhoneNumber", disablePadding: false, label: "ACTIONS", sortable: true, fontSize: '12px' },
    ];

    const handleSort = (property: string) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        onSortChange(property, newOrder);
    };


    return (
        <React.Fragment>
            <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={12}>
                    <TableContainer className={`${classes.tableBody} ${"scrollbox"} ${"on-scrollbar"}`} >
                        <Table stickyHeader>
                            <TableHead>
                                <StyledTableRow>
                                    {headCells.map((headCell) => (
                                        <StyledTableCell
                                            key={headCell.id}
                                            sortDirection={orderBy === headCell.id ? order : false}
                                            className={classes.tableHeaderStyle}
                                        >
                                            {headCell.id !== 'actions' ? (
                                                <TableSortLabel
                                                    active={orderBy === headCell.id}
                                                    direction={orderBy === headCell.id ? order : 'asc'}
                                                    onClick={() => handleSort(headCell.id)}
                                                >
                                                    {headCell.label}
                                                </TableSortLabel>
                                            ) : (
                                                headCell.label
                                            )}
                                        </StyledTableCell>
                                    ))}
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {uploadDemographicAPILogList?.map((row, index) => (
                                    <TableRow key={index}>
                                        <StyledCell className={classes.tableCellBody}>{row?.clientNo ?? ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>{row?.clT_NAME_1 ?? ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>{row?.firstName_ResponsibleParty ?? ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>{row?.lastName_ResponsibleParty ?? ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>{row?.phase ?? ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>{row?.billingAddressLine1 ?? ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>{row?.billingAddressLine2 ?? ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>{row?.billingCity ?? ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>{row?.billingState ?? ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>{row?.billingZipCode ?? ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>{row?.billingPhoneNumber ?? ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>{row?.createdDate ? moment(row.createdDate).format(state.GlobalUtils?.settingValue) : ''}</StyledCell>
                                        <StyledCell className={classes.tableCellBody}>
                                            <ViewMoreDemographicAPI row={row} />
                                        </StyledCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        {uploadDemographicAPILogList?.length === 0 ?
                            <Typography variant="h6" fontSize={15} color={'red'} gutterBottom marginTop={1}>
                                No records to display..
                            </Typography>
                            : null}
                    </TableContainer>
                </Grid>
                <Grid container spacing={0}>
                    <Grid item xs={6} sm={7}>
                        <div className="footer">
                            <Footer />
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={5}>
                        <TablePagination
                            rowsPerPageOptions={[25, 50, 100]}
                            component="div"
                            count={totalDemographicAPICount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={(event, newPage) => onPageChange(newPage)}
                            onRowsPerPageChange={(event) => {
                                const newRowsPerPage = parseInt(event.target.value, 10);
                                onRowsPerPageChange(newRowsPerPage);
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>


        </React.Fragment>
    )
}

export default UploadDemographicAPI